<template>
    <div v-show="colorList">
        <div class="tools_headding catgory_headding w-100 add_txt">
            <h4 class="heading5">
                Available Colors ( {{ color_list.length }} )
            </h4>
            <a
                href="javascript:;"
                @click="closeEdit(), setBackValueReset()"
                title="Close"
                class="ml-auto"
                ><img src="/maincss/images/tool_close.svg" alt=" "
            /></a>
        </div>
        <div class="">
            <label v-show="colorListValue && colorListValue.length">
                Present colors: ( {{ colorListValue.length }} )
            </label>
            <div
                v-show="colorListValue && colorListValue.length"
                class="ui-palette-box mb_20 present_color"
                style="
                    grid-template-columns: repeat(
                        auto-fill,
                        minmax(1.75rem, 1fr)
                    );
                    display: grid;
                    height: 28px;
                "
            >
                <div
                    v-for="(color, index) in colorListValue || []"
                    :key="index"
                    class="marign_color"
                    :class="
                        (selectedColorIndex == index
                            ? ' selected_color '
                            : '') +
                        (setDefaultColor == color ? ' selected_color ' : '')
                    "
                    @click="setActiveColor(color, index)"
                    :style="'display: grid; background:' + color + ';'"
                    v-tooltip="{ content: color, autoHide: false }"
                ></div>
            </div>
            <div
                v-show="color_list && color_list.length"
                class="ui-palette-box color_boxes_design"
                style="
                    grid-template-columns: repeat(
                        auto-fill,
                        minmax(1.75rem, 1fr)
                    );
                    display: grid;
                    height: 28px;
                "
            >
                <div v-for="(color, index) in color_list || []" :key="index">
                    <div
                        v-if="color.swatch_file != null && color.swatch_file"
                        :title="color.color_name"
                        :class="
                            'marign_color' +
                            (selectedColor == color.swatch_file
                                ? ' selected_color '
                                : '')
                        "
                        @click="
                            changeColor(color.swatch_file),
                                setActiveColor(color.swatch_file)
                        "
                        :style="'display: grid;'"
                        v-tooltip="color.color_value"
                    >
                        <img
                            :src="color.swatch_file"
                            alt="img"
                            class="swatch_img_tag_add_new"
                        />
                        <div class="input_color_check_box">
                            <form>
                                <div class="form-group">
                                    <input
                                        type="checkbox"
                                        :checked="
                                            selectedColor == color.swatch_file
                                        "
                                    />
                                    <label for="html"></label>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div
                        v-else
                        :title="color.color_name"
                        :class="
                            'marign_color' +
                            (selectedColor == color.color_value
                                ? ' selected_color '
                                : '')
                        "
                        @click="
                            changeColor(color.color_value),
                                setActiveColor(color.color_value)
                        "
                        :style="
                            'display: grid; background:' +
                            color.color_value +
                            ';'
                        "
                        v-tooltip="{
                            content: `${color.color_name}<br/>${color.color_value}<br/>${color.color_pms}`,
                            html: true
                        }"
                    >
                        <div class="input_color_check_box">
                            <form>
                                <div class="form-group">
                                    <div
                                        v-for="(
                                            colorlist, ind
                                        ) in colorListValue || []"
                                        :key="ind"
                                    >
                                        <span
                                            v-if="
                                                selectedColor ==
                                                    color.color_value ||
                                                colorlist == color.color_value
                                            "
                                            class="input_color_check_box_dot_icon"
                                        ></span>
                                        <!-- <span v-if="colorlist == color.color_value" class="input_color_check_box_dot_icon"></span> -->
                                        <span
                                            :class="
                                                color.color_value +
                                                selectedColor
                                            "
                                        ></span>
                                    </div>
                                    <input
                                        type="checkbox"
                                        :checked="
                                            selectedColor == color.color_value
                                        "
                                    />
                                    <label for="html"></label>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Color Picker Box -->
                <div
                    v-if="isFullColorSelected"
                    class="marign_color color-picker-box"
                    style="
                        position: relative;
                        width: 30px;
                        height: 30px;
                        border: 1px solid #ccc;
                        display: grid;
                        place-items: center;
                        cursor: pointer;
                    "
                >
                    <!-- Eyedropper icon -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-eyedropper"
                        viewBox="0 0 16 16"
                        style="color: #555; pointer-events: none"
                    >
                        <path
                            d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z"
                        />
                    </svg>
                    <!-- Transparent native color picker input -->
                    <input
                        type="color"
                        v-model="customColor"
                        @input="handleCustomColor"
                        style="
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            cursor: pointer;
                            border: none;
                            padding: 0;
                        "
                    />
                </div>
                <div
                    @click="
                        changeColor(fabric_color), setActiveColor(fabric_color)
                    "
                    class="febric_icon"
                    title="Use Fabric Color"
                    :style="'display: grid; background:' + fabric_color + ';'"
                >
                    <img
                        v-if="fabric_color != '#000000'"
                        src="/maincss/images/tshirt_icon_black.svg"
                        alt="img"
                    />
                    <img
                        v-else
                        src="/maincss/images/tshirt_icon_white.svg"
                        alt="img"
                    />
                    <div class="input_color_check_box">
                        <form>
                            <div class="form-group">
                                <span
                                    v-if="selectedColor == fabric_color"
                                    class="input_color_check_box_dot_icon"
                                ></span>
                                <input
                                    type="checkbox"
                                    :checked="selectedColor == fabric_color"
                                />
                                <label for="html1"></label>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <br />
        </div>
        <div>
            <div
                v-for="(unmatchedColor, unmatchedColorIndex) in unmatchedColors"
                :key="unmatchedColorIndex"
            >
                <div 
                    class="d-flex"
                    v-if="
                        (decorationType != 0 && decorationType != '0') ||
                        ((decorationType == 0 || decorationType == '0') && getServiceName && typeof getServiceName === 'string' && (getServiceName.toLowerCase().includes('print') || getServiceName.toLowerCase().includes('embroidery') || getServiceName.toLowerCase().includes('emb')))
                    "
                >
                    <div
                        class="ui-palette-box mb_20 present_color"
                        style="
                            grid-template-columns: repeat(
                                auto-fill,
                                minmax(1.75rem, 1fr)
                            );
                            display: grid;
                            height: 28px;
                        "
                    >
                        <span
                            class="marign_color"
                            :style="
                                'display: grid; background:' +
                                unmatchedColor +
                                ';'
                            "
                        ></span>
                    </div>
                    <span
                        >Color(<b>{{ unmatchedColor }}</b
                        >)
                        {{
                            decorationType == "1"
                                ? "Custom ink mix color"
                                : decorationType == "2"
                                ? "Custom thread color"
                                : decorationType == "0" && getServiceName && (getServiceName.toLowerCase().includes('print'))
                                ? "Custom ink mix color"
                                : decorationType == "0" && getServiceName && (getServiceName.toLowerCase().includes('embroidery') || getServiceName.toLowerCase().includes('emb'))
                                ? "Custom thread color"
                                : "Custom color"
                        }}
                        fee of
                        {{ icPriceFormat(non_standard_fees) }} applies</span
                    >
                </div>
            </div>
        </div>
        <div class="save_btn_right">
            <a href="#" @click="closeEdit(), setBackValueReset()">Done</a>
        </div>
    </div>
</template>
    <script>
import commonData from "@/common/common.data";
import { mapGetters } from "vuex";
export default {
    name: "ColorList",
    props: [
        "colorList",
        "colorListValue",
        "value",
        "closeEdit",
        "showColorList",
        "checkDefaultValue",
        "canvasActiveObj",
        "selectedDefaultHex",
        "vendor_colors_list",
        "decorationType"
    ],
    data: () => {
        return {
            selectedColor: undefined,
            product_data: [],
            color_list: [],
            fabric_color: "none",
            setDefaultColor: undefined,
            selectedColorIndex: 0,
            colourPath: {},
            unmatchedColors: [],
            non_standard_fees: 0,
            customColor: "#ff0000"
        };
    },
    computed: {
        ...mapGetters(["adminOptions"]),
        // Get service name from localStorage design data
        getServiceName() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].activeServiceData) {
                        const activeServiceData = design[activeGenderKey].activeServiceData;
                        // Check master_service first
                        if (activeServiceData.master_service) {
                            return activeServiceData.master_service.name || activeServiceData.master_service.service_name || null;
                        }
                        // Fallback to name property
                        return activeServiceData.name || null;
                    }
                }
            } catch (e) {
                console.error('Error parsing design from localStorage:', e);
            }
            return null;
        },
        // Get vendor fees from localStorage design data
        getVendorFees() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].item && design[activeGenderKey].item.VendorFees) {
                        return design[activeGenderKey].item.VendorFees || [];
                    }
                }
            } catch (e) {
                console.error('Error parsing design from localStorage:', e);
            }
            return [];
        },
        // Check if service has full color enabled
        isFullColorSelected() {
            try {
                const design = JSON.parse(localStorage.getItem('design') || localStorage.getItem('design_build') || '[]');
                if (design && design.length > 0) {
                    const activeGenderKey = parseInt(localStorage.getItem('active_gender_key') || '0');
                    if (design[activeGenderKey] && design[activeGenderKey].activeServiceData) {
                        const activeServiceData = design[activeGenderKey].activeServiceData;
                        const isFullColor = activeServiceData.is_full_color === true;
                        return isFullColor;
                    }
                }
            } catch (e) {
                console.error('Error checking full color service:', e);
            }
            return false;
        }
    },
    watch: {
        selectedDefaultHex: function () {
            let colorIndex = this.colorListValue.findIndex(
                (colorHex) => colorHex == this.selectedDefaultHex
            );
            if (colorIndex >= 0) {
                this.selectedColorIndex = colorIndex;
                this.setDefaultColor = this.colorListValue[colorIndex];
                this.selectedColor = this.colorListValue[colorIndex];
            }
            let colorsIndex = this.color_list.findIndex(
                (colorHex) => colorHex.color_value == "#GGGGGG"
            );
            if (colorsIndex !== -1) this.color_list.splice(colorsIndex, 1);
            this.prepareUnmatchedColors();
            this.calculateNonStandardFees();
        },
        setDefaultColor: function (new_val, old_value) {
            if (this.checkDefaultValue) {
                this.setDefaultColor = new_val;
            }
            console.log(old_value);
        },
        colorListValue: function (e) {
            this.colourPath = {};
            this.selectedColor = "";
            let colorIndex = this.colorListValue.findIndex(
                (colorHex) => colorHex == this.selectedDefaultHex
            );
            if (colorIndex >= 0) {
                this.selectedColorIndex = colorIndex;
                this.setDefaultColor = this.colorListValue[colorIndex];
                this.selectedColor = this.colorListValue[colorIndex];
            }
            console.log(e);
        },
        getServiceName: function () {
            // Recalculate fees when serviceName changes (only for PCNA - type 0)
            if (this.decorationType == 0 || this.decorationType == "0") {
                this.calculateNonStandardFees();
            }
        },
        getVendorFees: function () {
            // Recalculate fees when vendorFees change
            if (this.decorationType !== undefined && this.decorationType !== null) {
                this.calculateNonStandardFees();
            }
        },
        decorationType: function () {
            // Recalculate fees when decorationType prop changes
            this.calculateNonStandardFees();
        },
        vendor_colors_list: function (newData, oldData) {
            if (newData != oldData) {
                this.color_list = newData;
                // Update Fabric Color
                this.$root.$on("active_tshirt_color", (colorCode) => {
                    let selected_fabric_color = this.fabric_color;
                    this.fabric_color = colorCode;
                    if (this.selectedColor == selected_fabric_color) {
                        this.changeColor(colorCode);
                        this.setActiveColor(colorCode);
                    }
                });
            }
        }
    },
    methods: {
        calculateNonStandardFees() {
            // Skip if decorationType is not available
            if (this.decorationType === undefined || this.decorationType === null) {
                this.non_standard_fees = 0;
                return;
            }
            
            // Get vendor fees from localStorage
            const vendorFees = this.getVendorFees || [];
            
            // If no vendor fees available, set fee to 0
            if (!Array.isArray(vendorFees) || vendorFees.length === 0) {
                this.non_standard_fees = 0;
                return;
            }
            
            let targetService = null;
            let feeValue = 0;
            
            if (this.decorationType == 1 || this.decorationType == "1") {
                // Screen Print - look for custom_ink_mix or ink mix fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "custom_ink_mix" ||
                        (service.ecomm_display &&
                            service.ecomm_display.toLowerCase().includes("ink mix fee")) ||
                        (service.name &&
                            service.name.toLowerCase().includes("ink mix fee"))
                );
            } else if (this.decorationType == 2 || this.decorationType == "2") {
                // Embroidery - look for thread_fee or thread mix fee
                targetService = vendorFees.find(
                    (service) =>
                        service.type === "thread_fee" ||
                        (service.ecomm_display &&
                            service.ecomm_display.toLowerCase().includes("thread mix fee")) ||
                        (service.name &&
                            service.name.toLowerCase().includes("thread mix fee"))
                );
            } else if (this.decorationType == 0 || this.decorationType == "0") {
                // PCNA - check service name to determine if embroidery or print
                const serviceName = this.getServiceName;
                if (!serviceName || typeof serviceName !== 'string') {
                    // No service name found, no fee
                    targetService = null;
                } else {
                    const serviceNameLower = serviceName.toLowerCase();
                    const isEmbroidery = serviceNameLower.includes("embroidery") || serviceNameLower.includes("emb");
                    const isPrint = serviceNameLower.includes("print");
                    
                    if (isEmbroidery) {
                        // Look for thread_fee or thread mix fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "thread_fee" ||
                                (service.ecomm_display &&
                                    service.ecomm_display.toLowerCase().includes("thread mix fee")) ||
                                (service.name &&
                                    service.name.toLowerCase().includes("thread mix fee"))
                        );
                    } else if (isPrint) {
                        // Look for custom_ink_mix or ink mix fee
                        targetService = vendorFees.find(
                            (service) =>
                                service.type === "custom_ink_mix" ||
                                (service.ecomm_display &&
                                    service.ecomm_display.toLowerCase().includes("ink mix fee")) ||
                                (service.name &&
                                    service.name.toLowerCase().includes("ink mix fee"))
                        );
                    } else {
                        // If neither embroidery nor print, no fee
                        targetService = null;
                    }
                }
            }
            
            // Get fee from vendor service
            if (targetService && targetService.retail_cost) {
                feeValue = parseFloat(targetService.retail_cost) || 0;
            }
            
            this.non_standard_fees = feeValue;
            this.$forceUpdate();
        },
        rgbToHex(rgbColorString) {
            if (rgbColorString.match(/^#([0-9a-f]{3}){1,2}$/i))
                return rgbColorString.toUpperCase();
            const rgbValues = rgbColorString.match(/\d+/g);
            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString.toLowerCase();
            }
            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value
            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));
            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");
            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;
            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        triggerLoaderGrandChild(currentStatus) {
            if (!currentStatus) {
                setTimeout(() => {
                    this.$emit("triggerLoaderGrandChild", currentStatus);
                }, 1000);
            } else {
                this.$emit("triggerLoaderGrandChild", currentStatus);
            }
        },
        prepareUnmatchedColors() {
            this.unmatchedColors = [];
            let activeTshirtColor = localStorage.getItem("active_tshirt_color");
            this.colorListValue.forEach((colorHex) => {
                let colorMatch = this.color_list.findIndex(
                    (col) =>
                        col.color_value.toLowerCase() == colorHex.toLowerCase()
                );
                if (
                    colorMatch == -1 &&
                    activeTshirtColor.toLowerCase() != colorHex.toLowerCase()
                ) {
                    this.unmatchedColors.push(colorHex);
                }
            });
        },
        prepareColors(colors) {
            let allColors = [];
            commonData.colorShades.forEach((shade) => {
                colors.forEach((color) => {
                    if (color.color_value && color.shades) {
                        if (color.shades.includes(shade)) {
                            let alreadyExisted = allColors.find(
                                (col) => col.color_id == color.color_id
                            );
                            if (!alreadyExisted) {
                                allColors.push(color);
                            }
                        }
                    }
                });
            });
            colors.forEach((color) => {
                if (color.color_value) {
                    if (!color.shades || color.shades.length == 0) {
                        allColors.push(color);
                    }
                }
            });
            return allColors;
        },
        setDefaultcolorHighlight() {},
        setActiveColor(color, color_index = null) {
            this.setDefaultColor = undefined;
            this.selectedColor = color;
            if (color_index != null) {
                this.selectedColorIndex = color_index;
            }
            this.$forceUpdate();
            var activeObject = this.canvasActiveObj.getActiveObject();
            if (this.colorListValue.length == 0 && activeObject) {
                activeObject.fill = color;
                activeObject.dirty = true;
                /* eslint-disable */
                this.canvasActiveObj.objectCaching = false;
                /* eslint-enable */
                this.canvasActiveObj.renderAll();
            }
        },
        handleCustomColor(event) {
            const selected = event.target.value;
            this.changeColor(selected);
            this.setActiveColor(selected);
        },
        changeColor(e) {
            if (e == null) {
                return false;
            }
            let color = e;
            let _this = this;
            _this.triggerLoaderGrandChild(true);
            /* eslint-disable */
            if (_this.selectedColor) {
                var activeObject = _this.canvasActiveObj.getActiveObject();
                if (activeObject) {
                    if (activeObject._objects && activeObject._objects.length) {
                        let localColPathArr = [];
                        let pathLength = 0;
                        if (Object.keys(_this.colourPath).length === 0) {
                            _this.colorListValue.forEach(function (val, ind) {
                                let localPathArr = [];
                                activeObject._objects.forEach(function (
                                    e,
                                    index
                                ) {
                                    if (
                                        _this.rgbToHex(val) ==
                                        _this.rgbToHex(e.fill)
                                    ) {
                                        localPathArr.push(index);
                                        e.fill = _this.rgbToHex(e.fill);
                                    }
                                    if (
                                        activeObject._objects.length - 1 ==
                                        index
                                    ) {
                                        localColPathArr[val] = localPathArr;
                                    }
                                });
                                if (_this.colorListValue.length - 1 == ind) {
                                    _this.colourPath = localColPathArr;
                                }
                            });
                            pathLength = _this.colourPath.length;
                        }
                        let noOfKey = Object.keys(_this.colourPath).filter(
                            (key) => key.includes("@")
                        );
                        let noOfWord = "";
                        let localColor = _this.rgbToHex(color);
                        let localSelectedColor = _this.rgbToHex(
                            _this.selectedColor
                        );
                        for (let [index, e] of Object.entries(
                            activeObject._objects
                        )) {
                            index = parseInt(index);
                            if (
                                _this.colourPath.hasOwnProperty(
                                    localSelectedColor
                                )
                            ) {
                                if (
                                    localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                    _this.colourPath[
                                        localSelectedColor
                                    ].includes(index)
                                )
                                    e.fill = localColor;
                            } else if (noOfKey.length > 0) {
                                noOfWord = "";
                                for (let member in noOfKey) {
                                    noOfWord += "@";
                                }
                                if (
                                    localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                    _this.colourPath[
                                        localSelectedColor + noOfWord
                                    ].includes(index)
                                )
                                    e.fill = localColor;
                            } else {
                                if (
                                    localSelectedColor ==
                                        _this.rgbToHex(e.fill) &&
                                    !_this.colourPath[
                                        localSelectedColor
                                    ].includes(index)
                                )
                                    e.fill = localColor;
                            }
                            if (activeObject._objects.length - 1 == index) {
                                let outPut = Object.keys(
                                    _this.colourPath
                                ).filter((key) => key.includes(localColor));
                                let indexText = "";
                                if (outPut.length > 0) {
                                    for (let member in outPut) {
                                        indexText += "@";
                                    }
                                }
                                if (localColor in _this.colourPath) {
                                    let currentPaths =
                                        _this.colourPath[localSelectedColor];
                                    delete _this.colourPath[localSelectedColor];
                                    _this.colourPath[localColor + indexText] =
                                        currentPaths;
                                } else if (
                                    localSelectedColor in _this.colourPath
                                ) {
                                    let currentPaths =
                                        _this.colourPath[localSelectedColor];
                                    delete _this.colourPath[localSelectedColor];
                                    _this.colourPath[localColor] = currentPaths;
                                } else if (noOfKey.length > 0) {
                                    let currentPaths =
                                        _this.colourPath[
                                            localSelectedColor + noOfWord
                                        ];
                                    delete _this.colourPath[
                                        localSelectedColor + noOfWord
                                    ];
                                    _this.colourPath[localColor] = currentPaths;
                                }
                            }
                        }
                        _this.selectedColor = localColor;
                        // for one canvas
                        _this.colorListValue[this.selectedColorIndex] =
                            localColor;
                        _this.canvasActiveObj.objectCaching = false;
                        // for all canvas
                        _this.canvasActiveObj.renderAll();
                        _this.$emit("undoAndRedoImageColor");
                        _this.showColorList();
                    } else {
                        _this.setValue(color);
                    }
                }
            } else this.setValue(color);
            /* eslint-enable */
            this.selectedColor = color;
            this.prepareUnmatchedColors();
            _this.triggerLoaderGrandChild(false);
        },
        setValue(e) {
            this.$emit("set-value", e, this.selectedColor);
        },
        setBackValueReset() {
            this.selectedColorIndex = 0;
        }
    },
    mounted() {
        this.fabric_color = localStorage.getItem("active_tshirt_color");
        // Set default color if swatches in the select color
        if (this.fabric_color == "null") {
            this.fabric_color = "#d3d3d3";
        }
        if (this.vendor_colors_list.length > 0) {
            let colorIndex = this.vendor_colors_list.findIndex(
                (colorHex) => colorHex.color_value == "#GGGGGG"
            );
            /* eslint-disable */
            if (colorIndex !== -1)
                this.vendor_colors_list.splice(colorIndex, 1);
            this.color_list = this.vendor_colors_list;
            /* eslint-enable */
            // Update Fabric Color
            this.$root.$on("active_tshirt_color", (colorCode) => {
                let selected_fabric_color = this.fabric_color;
                this.fabric_color = colorCode;
                if (this.selectedColor == selected_fabric_color) {
                    this.changeColor(colorCode);
                    this.setActiveColor(colorCode);
                }
            });
        }
        // Calculate fees on mount
        this.$nextTick(() => {
            this.calculateNonStandardFees();
        });
    }
};
</script>
    <style>
.marign_color {
    margin: 2px;
    border: 1px solid rgb(73, 70, 70);
}
.marign_color:hover {
    border: 2px solid black;
    margin: 0px;
}
.selected_color {
    border: 2px solid black;
    margin: 0px;
}
.design_studio_tool .ui-palette-box.present_color .marign_color.selected_color {
    border: 1px solid #0079c1 !important;
}
.design_studio_tool
    .ui-palette-box.present_color
    .marign_color.selected_color:after {
    content: "";
    width: 29px;
    display: block;
    background: #0079c1;
    height: 2px;
    position: absolute;
    bottom: -7px;
    z-index: 9;
}
.color-picker-box {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    overflow: hidden;
}
</style>
    
    